import OTPSession from '../otpSession+UI/otpSession';
import ChangePasswordFormSession from '../change-password/changePasswordTs';
import ConfirmChangePasswordFormSession from '../change-password/confirmPasswordTs';
import LanguageFormSession from '../set-language/languageFormTs';
import DrsDenyForm from '../drs-deny/drsDenyTs';
import ProfileOverviewFormSession from '../profile-overview/profileOverviewTs';
import ChangeUsernameFormSession from '../change-username/changeUsernameTs';
import ChangeUsernameSuccessFormSession from '../change-username/change-username-success/changeUsernameSuccessTs';
import ChangePasswordSuccessFormSession from '../change-password/change-password-success/changePasswordSuccessTs';
import ChangeRecoveryNumberFormSession from '../change-recovery-number/changeRecoveryNumberTs';
import ChangeRecoveryNumberSuccessFormSession from '../change-recovery-number/change-recovery-number-success/changeRecoveryNumberSuccessTs';
import UpdateMultiFactorAuthSession from '../update-multi-factor-auth/updateMultiFactorauthFormTs';
import ProfilePasskeySettingsFormSession from '../pass-key/profile-pass-key-settings/profile-pass-key-settingsT';
import UpdateMultiAuthSuccessFormSession from '../update-multi-factor-auth/update-multi-auth-success/updateMultiAuthSuccessTs';
import RegisterPassKeyPromptSession from '../pass-key/register-pass-key-prompt/register-pass-key-promptTs';
import RegisterPassKeyFormSession from '../pass-key/pass-key-register-form/pass-key-register-formTs';
import PassKeySuccessFormSession from '../pass-key/pass-key-terms-success-form/pass-key-terms-success-formTs';
import PasskeyDeleteSuccessForm from '../pass-key/pass-key-delete-success/pass-key-delete-successFormTs';
import PasskeyDeleteFailureForm from '../pass-key/pass-key-delete-failure/pass-key-delete-failureFormTs';
import RenamePasskeyFormSession from '../pass-key/pass-key-rename/passkeyRenameFormTs';
import PasskeyRenameSuccessFormSession from '../pass-key/pass-key-rename-success/passkeyRenameSuccessTs';


const xmui: com.ts.mobile.sdk.UIHandler = (window as any).xmui;
let clientContextObj: object;

function CustomUIHandler() {
    (xmui as any).XmUIHandler.call(this);
}

CustomUIHandler.prototype = Object.create((xmui as any).XmUIHandler.prototype);
CustomUIHandler.prototype.constructor = CustomUIHandler;

CustomUIHandler.prototype.createOtpAuthSession = (
  title: string,
  username: string,
  possibleTargets: Array<com.ts.mobile.sdk.OtpTarget>,
  autoExecedTarget: com.ts.mobile.sdk.OtpTarget | null
): com.ts.mobile.sdk.UIAuthenticatorSessionOtp => {
  return new OTPSession(title, username, possibleTargets, autoExecedTarget);
};

// Transmit provided code
// Invoked anytime when the journey is ended

CustomUIHandler.prototype.controlFlowEnded =
function controlFlowEnded(error, clientContext)
{
    if (error) {
      if ( error?._data?.failure_data?.reason?.data.code === 'RC01'){
          const url = clientContext['cookieService'].get('redirect_uri');
          const state = clientContext['cookieService'].get('state');
          const errorCode  = 'rc01';
          let appendChar = '?';
          if (url.includes('?'))
          {
              appendChar = '&';
          }
          window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=rc01'
          + '&lang=' + clientContext['cookieService'].get('lang')
          + '&state=' + state;
      }
      console.log('error: ', error);
    } else {
    console.log('control flow ended');
    }
  };

CustomUIHandler.prototype.createFormSession = (
  formId: string,
  payload: any
): com.ts.mobile.sdk.UIFormSession => {
  console.log('createFormSession', formId);
  switch (formId) {
      case 'cpmform':
        return new ProfileOverviewFormSession(formId, payload);

      case 'language':
        return new LanguageFormSession(formId, payload);

      // case 'drs_deny_error':
      //    return new DrsDenyForm(formId, pay  load);

      case 'CPMchangeUsernameProfile':
         return new ChangeUsernameFormSession(formId, payload);

      case 'successChangeUsername':
          return new ChangeUsernameSuccessFormSession(formId, payload);

      case 'successChangePassword':
        return new ChangePasswordSuccessFormSession(formId, payload);

      case 'CPMchangeRecoveryNumberProfile':
         return new ChangeRecoveryNumberFormSession(formId, payload);

      case 'successChangeMobileNumber':
          return new ChangeRecoveryNumberSuccessFormSession(formId, payload);

      case 'CPMprofileUpdateMFA':
          return new UpdateMultiFactorAuthSession(formId, payload);

        case 'CPMpasskeyform':
          return new ProfilePasskeySettingsFormSession(formId, payload);

        case 'successChangeUpdateMFA':
            return new UpdateMultiAuthSuccessFormSession(formId, payload);

        case 'CPMregisterPasskey':
          return new RegisterPassKeyPromptSession(formId, payload);

        case 'CPMpasskeyAddSuccessForm':
            return new PassKeySuccessFormSession(formId, payload);

        case 'CPMpasskeyDeleteSuccess':
            return new PasskeyDeleteSuccessForm(formId, payload);

        case 'CPMpasskeyDeleteFailure':
            return new PasskeyDeleteFailureForm(formId, payload);

        case 'CPMprofileRenamePasskey':
            return new RenamePasskeyFormSession(formId, payload);

        case 'CPMpasskeyRenameSuccess':
            return new PasskeyRenameSuccessFormSession(formId, payload);
  }
};

CustomUIHandler.prototype.createPasswordAuthSession = (
  title: string,
  username: string,
) => {
  console.log('PasswordAuthSession invoke');
  const flow = clientContextObj['cookieService'].get('customFlow');
  if (flow === 'oldPassword'){
    return new ChangePasswordFormSession(title, username);
  }
  else if (flow === 'newPassword'){
    return new ConfirmChangePasswordFormSession(title, username);
  }
  else{
    return (xmui as any).createPasswordAuthSession(title, username);
  }
};

CustomUIHandler.prototype.handlePolicyRedirect  = (
  redirectType: com.ts.mobile.sdk.RedirectInput, policyId: string | null,
  userId: string | null, additionalParameters: object | null, clientContext: object | null
) => {

    clientContext['UserId'] = userId;
    return new Promise((resolve, reject) => {
        try {
          resolve(com.ts.mobile.sdk.RedirectInput.create(com.ts.mobile.sdk.RedirectResponseType.RedirectToPolicy));
        }
        catch (e) {
          console.log('handlePolicyRedirect error: ', e);
        }
    });
};


CustomUIHandler.prototype.handlePolicyRejection =
(title, text, buttonText, failureData, actionContext, clientContext) => {

  if (failureData?.reason?.data?.error === 'register' ||
      failureData?.reason?.data?.error === 'forgotusername' ||
      failureData?.reason?.data?.error === 'account_forgotusername' ||
      failureData?.reason?.data?.error === 'RC01'){

    const errorCode = failureData.reason.data.error;
    const errorDesc = failureData.reason.data.error_desc;
    const url = clientContext['redirect_uri'];
    const state = clientContext['state'];
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }

    return window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=' + errorDesc
    + '&lang=' + clientContext['cookieService'].get('lang')
    + '&state=' + state;

  }
  else{
    return Promise.resolve(com.ts.mobile.sdk.ConfirmationInput.create(-1));
  }
};


CustomUIHandler.prototype.processJsonData = (
  jsonData: object, actionContext: com.ts.mobile.sdk.PolicyAction, clientContext: object | null
): Promise<com.ts.mobile.sdk.JsonDataProcessingResult> => {
  clientContextObj = clientContext;
  return new Promise((resolve, reject) => {
    if (jsonData['flow']) {
      clientContext['flow'] = jsonData['flow'];
      clientContextObj['cookieService'].set('customFlow', clientContext['flow'], undefined, undefined, null, true, 'None');
    }
    if (jsonData['username']) { clientContext['username'] = jsonData['username']; }
    if (jsonData['DisplayName']) { clientContext['DisplayName'] = jsonData['DisplayName']; }
    if (jsonData['passkeyDetails']) { clientContext['passkeyDetails'] = jsonData['passkeyDetails']; }
    resolve(com.ts.mobile.sdk.JsonDataProcessingResult.create(true));
  });
};

export default CustomUIHandler;
